import {Component}               from '@angular/core';
import {AsstSummarizerComponent} from '../../../../../comps/asst/asst-summarizer/asst-summarizer.component';
import {MenuDragPanelBase}       from '../menu-drag-panel-base';

@Component({
			   selector   : 'app-menu-drag-panel-asst',
			   imports: [
				   AsstSummarizerComponent
			   ],
			   templateUrl: './menu-drag-panel-asst.component.html',
			   styleUrl   : './menu-drag-panel-asst.component.css'
		   })
export class MenuDragPanelAsstComponent extends MenuDragPanelBase {

}
